import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { getDefaultName } from '../../utils';

/**
 * Participant dashboard sidebar: main nav + nested contest shortcuts (same routes as before).
 */
export default function ParticipantDashboardNavWidget({
    translate,
    courses = null,
    role = 'participant',
}) {
    return (
        <aside className="sidebar mt-2 participant-dashboard-nav" id="sidebar">
            <ul className="participant-dashboard-nav__list text-2 kfont lan-text-right">
                <li className="participant-dashboard-nav__item">
                    <NavLink
                        to="/dashboard"
                        exact
                        className="participant-dashboard-nav__row"
                        activeClassName="participant-dashboard-nav__row--active"
                    >
                        <span className="participant-dashboard-nav__chev" aria-hidden>
                            <i className="fas fa-angle-right" />
                        </span>
                        <span className="participant-dashboard-nav__label text-color-primary">
                            {translate('Dashboard')}
                        </span>
                    </NavLink>
                </li>
                <li className="participant-dashboard-nav__item">
                    <NavLink
                        to="/profile"
                        className="participant-dashboard-nav__row"
                        activeClassName="participant-dashboard-nav__row--active"
                    >
                        <span className="participant-dashboard-nav__chev" aria-hidden>
                            <i className="fas fa-angle-right" />
                        </span>
                        <span className="participant-dashboard-nav__label text-color-primary">
                            {translate('Manage Profile')}
                        </span>
                    </NavLink>
                </li>
                <li className="participant-dashboard-nav__item">
                    <NavLink
                        to="/contests"
                        className="participant-dashboard-nav__row"
                        activeClassName="participant-dashboard-nav__row--active"
                    >
                        <span className="participant-dashboard-nav__chev" aria-hidden>
                            <i className="fas fa-angle-right" />
                        </span>
                        <span className="participant-dashboard-nav__label text-color-primary">
                            {translate('Contests')}
                        </span>
                    </NavLink>
                </li>

                {role && role === 'participant' && (
                    <li className="participant-dashboard-nav__item participant-dashboard-nav__item--nested">
                        <div className="participant-dashboard-nav__nested">
                            {courses &&
                                courses.map((item) => (
                                    <Link
                                        key={item.id}
                                        to="/contests"
                                        className="participant-dashboard-nav__contest-link color-orange kfont"
                                    >
                                        <span
                                            className="participant-dashboard-nav__chev participant-dashboard-nav__chev--trophy"
                                            aria-hidden
                                        >
                                            <i className="fas fa-trophy" />
                                        </span>
                                        <span className="participant-dashboard-nav__label">
                                            {getDefaultName(item.names)}
                                        </span>
                                    </Link>
                                ))}
                            {!courses && (
                                <p className="participant-dashboard-nav__empty mb-0">
                                    {translate(
                                        'There are no current contests at the moment.'
                                    )}
                                </p>
                            )}
                        </div>
                    </li>
                )}

                {role === 'participant' && (
                    <li className="participant-dashboard-nav__item">
                        <NavLink
                            to="/support"
                            isActive={(match, location) =>
                                !!match || location.pathname.startsWith('/support')
                            }
                            className="participant-dashboard-nav__row"
                            activeClassName="participant-dashboard-nav__row--active"
                        >
                            <span className="participant-dashboard-nav__chev" aria-hidden>
                                <i className="fas fa-angle-right" />
                            </span>
                            <span className="participant-dashboard-nav__label text-color-primary">
                                {translate('Support')}
                            </span>
                        </NavLink>
                    </li>
                )}
            </ul>
        </aside>
    );
}
